<mat-card appearance="outlined" class="mixed-round-border demand-status--print ">
  <app-demand-status-info [demand]="demand" id="pdfDemandStatus"></app-demand-status-info>
</mat-card>

<mat-card appearance="outlined" class="lineo-tab-group mixed-round-border no-padding ">
  <app-demand-tab-print [demand]="demand" [isPdf]="true" (mapEvent)="mapIsReady.emit(true)"></app-demand-tab-print>
  <div class="print-break-before">
    <app-treatment-monitoring-print [demand]="demand" [showEveryMessages]="true" [forPdf]="true"></app-treatment-monitoring-print>
  </div>
</mat-card>